import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/core/services/event.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { filter } from 'rxjs/operators';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PropertiesService } from '../../services/properties.services';
import { PermissionsService } from 'src/app/core/services/permissions.service';

@Component({
  selector: 'app-portals',
  templateUrl: './portals.component.html',
  styleUrls: ['./portals.component.scss']
})
export class PortalsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  dataToFormInitPortals: any
  @Input()
  propertyPortalsData: any
  propertyPortalsForm!: FormGroup;
  isView = false;
  subscription!: Subscription;
  langValue: any;
  @ViewChild('content1', { static: true }) content1!: ElementRef;
  modalPortalLogs!: NgbModalRef;
  logsTitleFilters: any;
  logsFilters: any[] = [];
  @Input()
  propertyId: any;
  @ViewChild('formElementRef') formElementRef!: ElementRef;
  @Input()
  property: any;

  constructor(
    private eventService: EventService, private formBuilder: FormBuilder, private cdr: ChangeDetectorRef,
    private langService: LanguageService, private modalService: NgbModal, private propertiesService: PropertiesService,
    private renderer: Renderer2, private permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.langValue = this.langService.getCurrentLang();
    this.subscription = new Subscription();
    this.initFormValidation();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const subscriptionSubmitted = this.eventService.subscribe('get-data-tab-portals', () => {
        this.propertyPortalsData.data = this.propertyPortalsForm.value;
        this.cdr.detectChanges();
        this.eventService.broadcast('check-warning-add-property');
      });
      this.subscription.add(subscriptionSubmitted);
      this.isView = true
      setTimeout(() => {
        this.setEletemtConfig()
      });

    });
  }

  /**
* Form data get
*/
  get form() {
    return this.propertyPortalsForm.controls;
  }

  dynamicDataForm() {
    if (this.propertyPortalsData === undefined || this.propertyPortalsData === null)
      this.propertyPortalsData = { data: {} };

    for (let p of this.dataToFormInitPortals.portals) {
      this.propertyPortalsData.data[`portal${p.id}`] = [this.propertyPortalsData.data[`portal${p.id}`] === true ? true : false];
    }
  }

  /**
 * Form Validation
 */
  initFormValidation() {
    this.dynamicDataForm();
    this.propertyPortalsForm = this.formBuilder.group(this.propertyPortalsData.data);
  }

  getDateUpdate(portalId: any) {
    const ext = this.propertyPortalsData?.externalPortals?.find((x: any) => x.portalId === portalId);
    return ext?.updatedAt;
  }
  getLastUpdatedDate(portalId: any) {
    const ext = this.propertyPortalsData?.externalPortals?.find((x: any) => x.portalId === portalId);
    return ext?.lastUpdatedAt;
  }
  getUpdatingStatus(portalId: any) {
    const ext = this.propertyPortalsData?.externalPortals?.find((x: any) => x.portalId === portalId);
    return ext?.updatingStatus;
  }
  checkLogs(portalId: any) {
    const plogs = this.propertyPortalsData?.portalsLogs?.find((x: any) => x.portalId === portalId);
    return plogs ? true : false;
  }

  getMessagePortalLogs(portalId: any) {
    const plogs = this.propertyPortalsData?.portalsLogs?.find((x: any) => x.portalId === portalId);
    return plogs ? plogs.message : '';
  }

  getCountPortalLogs(portalId: any) {
    const plogs = this.propertyPortalsData?.portalsLogs?.filter((x: any) => x.portalId === portalId);
    return plogs?.length > 0 ? plogs.length : 0;
  }

  isActivateOnAllProperties(portalId: any) {
    const ext = this.propertyPortalsData?.aux?.find((x: any) => x.id === portalId);
    return ext?.activateOnAllProperties;
  }

  openModal(portalId: any) {
    const p = this.dataToFormInitPortals.portals.find((x: any) => x.id === portalId);
    this.logsTitleFilters = p.name;
    this.logsFilters = this.propertyPortalsData?.portalsLogs?.filter((x: any) => x.portalId === portalId);
    this.modalPortalLogs = this.modalService.open(this.content1, {
      backdropClass: 'modal-portalslogs-zindex', size: 'xxl', centered: true, backdrop: 'static', keyboard: false
    });

  }
  setEletemtConfig() {
    if (!this.permissionsService.checkMasterPermission('EDIT_PROPERTIES', this.property?.store?.id) && !this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'EDIT_PROPERTIES') && this.property) {
      if (this.formElementRef.nativeElement) {
        this.renderer.setStyle(this.formElementRef.nativeElement, 'pointer-events', 'none')
        const parentElement = this.formElementRef.nativeElement.parentElement;
        if (parentElement)
          this.renderer.setStyle(parentElement, 'cursor', 'not-allowed')
      }
    }
  }

  ngOnDestroy(): void {
    this.eventService.broadcast('get-data-tab-portals');
    this.subscription.unsubscribe();
  }
}
